import { createFileRoute } from '@tanstack/react-router'
import { SubCustomersSection } from '@spcc/domains/sub-customers'

export const Route = createFileRoute('/customers')({
  component: CustomersPage,
})

function CustomersPage() {
  return <SubCustomersSection />
}
